// extracted by mini-css-extract-plugin
module.exports = {"edit-result-btn":"EditResult_edit-result-btn__HaJsQ"};